import {
  styled as muiStyled,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Stack,
  Typography,
  Divider,
  TextField,
} from '@mui/material';

import { COLORS } from '../../../../themes/colors';
import styled from 'styled-components';

export const Wrapper = muiStyled(Stack)(() => ({
}));

export const Content = styled.div`
  display: flex;
  flex-direction: row;

  & .filter-container  {
    border-radius: 0;
  }

  & .filter-container {
    :first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
  
  & .filter-container {
    :last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Overlay = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: transparent;
`;

export const Container = muiStyled(Stack)(() => ({
  flexDirection: 'column',
  paddingBottom: '16px',
}));

export const DateContainer = muiStyled(Stack)(() => ({
  flexDirection: 'column',
  width: '100%',
  gap: '8px'
}));

export const PeriodTitle = muiStyled(Typography)(() => ({
  fontFamily: 'Work Sans',
  fontWeight: 600,
  fontSize: '14px',
  color: `${COLORS.DARK['+3']}`,
}));

export const DividerStyled = muiStyled(Divider)(() => ({
  marginTop: '8px',
}));

export const PeriodContent = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
`;

export const DateContent = muiStyled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'flex-end',
  justifyContent: 'center',
  gap: '10px',
  width: '100%',
}));

export const TextFieldStyled = muiStyled(TextField)(() => ({
  color: `${COLORS.DARK['+5']}`,
  fontFamily: 'Work Sans',
  fontWeight: 400,
  fontSize: '14px',

  '& .MuiInput-underline:before': {
    borderBottom: `1px solid ${COLORS.DARK['+1']}`,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: `${COLORS.PRIMARY.BLUE['-4']}`,
  },
}));

export const ToStyled = muiStyled(Typography)(() => ({
  color: `${COLORS.BLACK}`,
  fontFamily: 'Work Sans',
  fontWeight: 400,
  fontSize: '14px',
  marginBottom: '8px',
}));

// When have radio
export const FormControlStyled = muiStyled(FormControl)(() => ({}));

export const RadioGroupStyled = muiStyled(RadioGroup)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignSelf: 'flex-start',
}));

export const RadioGroupSelect = muiStyled(RadioGroup)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignSelf: 'flex-start',
}));

export const FormLabelStyled = muiStyled(FormControlLabel)(() => ({
  color: `${COLORS.DARK['+5']}`,
}));

export const LabelStyled = muiStyled(Typography)(() => ({
  fontFamily: 'Work Sans',
  fontWeight: 400,
  fontSize: '14px',
}));

export const RadioStyled = muiStyled(Radio)(() => ({
  color: `${COLORS.PRIMARY.BLUE['-4']}`,
  '&.Mui-checked': {
    color: `${COLORS.PRIMARY.BLUE['-4']}`,
  },
}));
